import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      meta: { title: '清道小工单' },
      component: () => import('@/views/login/index')
    },
    {
      path: '/qingdao-work-order',
      component: () => import('@/views/qingdao-work-order/index'),
      // redirect: '/qingdao-work-order/work-order-list',
      children: [
        {
          path: '/qingdao-work-order/work-order-list',
          meta: { title: '工单' },
          component: () => import('@/views/qingdao-work-order/pages/work-order-list')
        },
        {
          path: '/qingdao-work-order/report-work-plan-list',
          meta: { title: '报工明细' },
          component: () => import('@/views/qingdao-work-order/pages/report-work-plan-list')
        },
        {
          path: '/qingdao-work-order/audit-work-plan-list',
          meta: { title: '审核报工' },
          component: () => import('@/views/qingdao-work-order/pages/audit-work-plan-list')
        },
        {
          path: '/qingdao-work-order/salary',
          meta: { title: '薪资' },
          component: () => import('@/views/qingdao-work-order/pages/salary')
        }
      ]
    }
  ]
})

// 前置路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = localStorage.getItem('login_token')
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

// 后置路由守卫
router.afterEach((to) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
